import api from "../../services/api";
import $ from "jquery";
import _ from "lodash";
import { mapMutations, mapGetters } from "vuex";
import moment from "moment";

export default {
	data: function() {
		return {
			loading: false,
			items: [],
			settingsMenu: [],
			vehicleMenu: [],
			tripMenu: [],
			panelVisible: false,
			tabIndex: 3,
			disabledTabs: true,
			tabActive: false,
			isMenuOpen: true,

			collapseMenu1: true,
			collapseMenu2: false,
			collapseMenu3: false,
			collapseMenu4: false,

			menuExpanded1Selected: false,
			menuExpanded2Selected: false,
			menuExpanded3Selected: false,
			menuExpanded4Selected: false,

			currentDate: "",
			currentTime: ""
		};
	},

	created() {
		this.getData();
		this.clock();
		window.$ = $;
	},

	/* metodi */
	methods: {
		...mapMutations(["settingsMenuLabels"]),
		clock: function() {
			var self = this;

			moment.locale("it");

			setInterval(() => {
				var tempDate = moment();
				self.currentDate = tempDate.format("dddd DD/MM/YYYY");
				self.currentTime = "ORE " + tempDate.format("LTS");
			}, 1000);
		},
		selectExpandedMenu: function() {
			var self = this;
			var url = this.$route;
			if (url) {
				switch (url.name) {
					case "REPORT":
					case "REPORT_TRIPS":
					case "REPORT_UTILIZATION":
					case "REPORT_JOURNEY":
					case "REPORT_BEHAVIORS":
					case "REPORT_ALARMS":
					case "REPORT_DIAGNOSTIC":
					case "REPORT_TRIP_EVENTS":
					case "REPORT_LAST_DIAGNOSTIC":
						self.collapseMenu3 = true;
						self.collapseMenu1 = false;
						self.collapseMenu2 = false;
						self.collapseMenu4 = false;

						self.menuExpanded1Selected = false;
						self.menuExpanded2Selected = false;
						self.menuExpanded3Selected = true;
						self.menuExpanded4Selected = false;
						break;

					case "VEHICLES_LIST":
					case "VEHICLES_LIST_BOX":
					case "VEHICLE_DETAIL":
					case "DRIVERS_LIST":
					case "DRIVERS_DETAIL":
					case "DRIVERS_LIST_BOX":
					case "":
						self.collapseMenu2 = true;
						self.collapseMenu4 = false;
						self.collapseMenu1 = false;
						self.collapseMenu3 = false;

						self.menuExpanded1Selected = false;
						self.menuExpanded2Selected = true;
						self.menuExpanded3Selected = false;
						self.menuExpanded4Selected = false;
						var urlName = url.name;
						if (urlName == "VEHICLES_LIST") urlName = "VEHICLES_LIST_BOX";
						if (urlName == "DRIVERS_LIST") urlName = "DRIVERS_LIST_BOX";
						if (urlName == "VEHICLE_DETAIL") urlName = "VEHICLES_LIST_BOX";
						if (urlName == "DRIVERS_DETAIL") urlName = "DRIVERS_LIST_BOX";
						
						if (self.$refs.vehiclePanel) {
							self.$nextTick(function() {
								var vehiclePanel = self.$refs.vehiclePanel.kendoWidget();
								vehiclePanel.select(`#${urlName}`);
							});
						}
						break;

					case "ALARMS":
					case "GEOLOCATION":
					case "TRIPS_DATA":
					case "TRIPS_DIAGNOSTIC_DATA":
					case "TRIPS_ROUTES":
					case "GEOFENCES":
					case "GEOFENCES_LIST_BOX":
					case "GEOFENCE_DETAIL":
					case "TRIPS_POI":
						self.collapseMenu1 = true;
						self.collapseMenu2 = false;
						self.collapseMenu3 = false;
						self.collapseMenu4 = false;

						self.menuExpanded1Selected = true;
						self.menuExpanded2Selected = false;
						self.menuExpanded3Selected = false;
						self.menuExpanded4Selected = false;

						var urlName = url.name;
						if (urlName == "GEOFENCES_LIST_BOX") urlName = "GEOFENCES";
						if (urlName == "GEOFENCE_DETAIL") urlName = "GEOFENCES";

						if (self.$refs.tripPanel) {
							self.$nextTick(function() {
								var trip = self.$refs.tripPanel.kendoWidget();
								trip.select(`#${urlName}`);
							});
						}
						break;
					case "PREFERENCES_SUPPORT_TABLES_BOX":
					case "PREFERENCES_SETTINGS_BOX":
					case "PREFERENCES_DETAIL_ALERT_BOX":
					case "PREFERENCES_ALERT_BOX":
						self.collapseMenu1 = false;
						self.collapseMenu2 = false;
						self.collapseMenu3 = false;
						self.collapseMenu4 = true;

						self.menuExpanded1Selected = false;
						self.menuExpanded2Selected = false;
						self.menuExpanded3Selected = false;
						self.menuExpanded4Selected = true;

						var urlName = url.name;
						if (urlName == "PREFERENCES_DETAIL_ALERT_BOX") urlName = "PREFERENCES_ALERT_BOX";

						if (self.$refs.tripPanel) {
							self.$nextTick(function() {
								var fp = self.$refs.prefPanel.kendoWidget();
								fp.expand("#setings_0");
								fp.select(`#${urlName}`);
							});
						}
						break;

					default:
						self.collapseMenu1 = true;
						self.collapseMenu2 = false;
						self.collapseMenu3 = false;
						self.collapseMenu4 = false;

						self.menuExpanded1Selected = false;
						self.menuExpanded2Selected = false;
						self.menuExpanded3Selected = false;
						self.menuExpanded4Selected = false;
						break;
				}
			}
		},
		getIfMenuIsVisible(key, child) {
			var existsScope =
				this.scopes.findIndex(item => {
					return item == key;
				}) >= 0;
			// var existsRoot = this.items.findIndex(item => {
			// 	return item.code == key;
			// }) >= 0;

			// var existsChild = false;
			// if (child && this.items.length > 0) {
			// 	var self = this;
			// 	for (var i = 0; i < this.items.length; i++) {
			// 		if (self.items[i].childs && self.items[i].childs.length > 0) {
			// 			var existsChild = self.items[i].childs.findIndex(item => {
			// 				return item.code == child;
			// 			}) >= 0;
			// 		}

			// 		if (existsChild) break;
			// 	}
			// }
			// else {
			// 	existsChild = true;
			// }

			// return existsRoot && existsChild;
			return existsScope;
		},
		onLogoClick() {
			this.tabIndex = 3;
			var fp = this.$refs.prefPanel;
			var fpQuery = fp.kendoWidget();
			fpQuery.collapse("#setings_0");
			fpQuery.select("");
		},
		onTabClick(menu) {
			switch (menu) {
				case "loc":
					this.collapseMenu3 = false;
					this.collapseMenu2 = false;
					this.collapseMenu4 = false;
					this.collapseMenu1 = !this.collapseMenu1;
					break;
				case "mezzi":
					this.collapseMenu1 = false;
					this.collapseMenu3 = false;
					this.collapseMenu4 = false;
					this.collapseMenu2 = !this.collapseMenu2;
					break;
				case "settings":
					this.collapseMenu1 = false;
					this.collapseMenu3 = false;
					this.collapseMenu4 = !this.collapseMenu4;
					this.collapseMenu2 = false;
					break;
				case "report":
					this.collapseMenu1 = false;
					this.collapseMenu2 = false;
					this.collapseMenu3 = true;
					this.collapseMenu4 = false;

					this.$router.push({
						name: "REPORT"
					});
					break;
			}
			// var fp = this.$refs.prefPanel;
			// var fpQuery = fp.kendoWidget();
			// fpQuery.collapse("#setings_0");
			// fpQuery.select("");
		},
		onSettingsPanelSelect(e) {
			this.tabIndex = 3;
		},
		logout() {
			this.$store.dispatch("logout").then(res => {
				this.$router.push({
					name: "login"
				});
			});
		},

		onOpenMenu() {
			this.isMenuOpen = true;
			var fp = this.$refs.prefPanel;
			if (fp) {
				var fpQuery = fp.kendoWidget();
				fpQuery.collapse("#setings_0");
			}
			this.selectExpandedMenu();
			this.$emit("on-open-menu");
		},
		onCloseMenu() {
			this.isMenuOpen = false;
			this.$emit("on-close-menu");
		},

		getData: function() {
			var self = this;
			this.loading = true;

			this.getMenuList(self);
		},

		getMenuList: function(self) {
			api.getMenuListData().then(res => {
				self.loading = false;
				self.items = res;

				// self.settingsMenu = _.filter(res, function(o) {
				// 	return o.code == "PREFERENCES_BOX";
				// });

				var tmpSettingsMenu = _.filter(res, function(o) {
					return o.code == "PREFERENCES_BOX";
				});
				_.forEach(tmpSettingsMenu, function(value, key) {
					self.settingsMenu.push.apply(self.settingsMenu, value.childs);
				});

				// if (self.settingsMenu && self.settingsMenu.length > 0) {
				// 	self.settingsMenu = self.settingsMenu.filter(item => {
				// 		return item.code != "PREFERENCES_ALERT_BOX";
				// 	});
				// }

				var tmpVehicle = _.filter(res, function(o) {
					return o.code == "VEHICLES_LIST_BOX" || o.code == "VEHICLES_MENU_BOX";
				});
				_.forEach(tmpVehicle, function(value, key) {
					for (var i = 0; i < value.childs.length; i++) {
						var child = value.childs[i];
						if (child.code == "VEHICLES_LIST") child.code = "VEHICLES_LIST_BOX";
						if (child.code == "DRIVERS_LIST") child.code = "DRIVERS_LIST_BOX";
					}
					self.vehicleMenu.push.apply(self.vehicleMenu, value.childs);
				});

				var tmpTrips = _.filter(res, function(o) {
					return o.code == "TRIPS";
				});
				_.forEach(tmpTrips, function(value, key) {
					self.tripMenu.push.apply(self.tripMenu, value.childs);
				});

				self.panelVisible = true;

				self.$nextTick(function() {
					self.selectExpandedMenu();
				});
				self.settingsMenuLabels(res);
			});
		},
		getMenuName: function(code) {
			var menu = this.items.find(item => {
				return item.code == code;
			});

			if (menu) return menu.label;

			return "";
		},
		getInnerMenuName: function(code, innerCode) {
			var menu = this.items.find(item => {
				return item.code == code;
			});

			if (menu) {
				if (menu.childs.length == 0) return menu.label;

				var innerMenu = menu.childs.find(item => {
					return item.code == innerCode;
				});

				if (innerMenu) return innerMenu.label;
			}

			return "";
		}
	},

	/* visualizzazione risultati */
	computed: {
		...mapGetters(["scopes"]),
		menuSelected: function() {
			var pathUrl = this.$route.path;
			this.selectExpandedMenu();
			return pathUrl;
		},
		userName: function() {
			return this.$store.getters.currentUser.name;
		},
		companyName: function() {
			return this.$store.getters.currentUser.company.description;
		},
		itemMenuList: function() {
			return [
				{
					field: "id",
					title: "id"
				},
				{
					field: "code",
					title: "code"
				},
				{
					field: "label_code",
					title: "label code"
				},
				{
					field: "label",
					title: "label"
				}
			];
		},
		getFleewaySSoUrl: function() {
			if (this.$store.getters.currentUser.sso_token) {
				if (this.$store.getters.currentUser.has_fleeway) {
					return `${this.$store.getters.currentUser.fleeway_sso_url}?token=${this.$store.getters.currentUser.sso_token}`;
				}

				return null;
			}

			return null;
		}
	}
};
